// extracted by mini-css-extract-plugin
export default {"container":"Verified_container__ZYQju","box":"Verified_box__rDxR8","checkmark":"Verified_checkmark__Jbbfo","loginLink":"Verified_loginLink__AO6KJ"};